import React from 'react'
import styled from 'styled-components'
import Icon, { ICON_SIZE } from 'components/Icon'
import { Flex } from 'components/Layout'
import { COLOR_INTENT } from 'Theme'

const TOP_EXPERT_MARKER_TOUCH_AREA = '40px'

const TopExpertWrapper = styled(Flex)`
  cursor: ${({ isLoading }) => (isLoading ? 'not-allowed' : 'pointer')};
`

interface TopExpertMarkerProps {
  color?: string
  fill?: string
  isTopExpert: boolean
  size?: string
}

export const TopExpertMarker: React.FC<React.PWC<TopExpertMarkerProps>> = ({
  color = COLOR_INTENT.TOP_EXPERT_MARKER.COLOR,
  fill = COLOR_INTENT.TOP_EXPERT_MARKER.FILL,
  isTopExpert,
  size = ICON_SIZE.PX_36,
  ...rest
}) => (
  <TopExpertWrapper
    width={TOP_EXPERT_MARKER_TOUCH_AREA}
    height={TOP_EXPERT_MARKER_TOUCH_AREA}
    alignItems="center"
    justifyContent="center"
    {...rest}
  >
    {isTopExpert ? (
      <Flex>
        <Icon.TopExpert size={size} color={color} fill={fill} />
      </Flex>
    ) : null}
  </TopExpertWrapper>
)
